import { types } from 'mobx-state-tree';


const INCOME_TYPES = {
    SALARY: 'salary',
    FULL_TIME_HOURLY: 'full-time-hourly',
    PART_TIME_HOURLY: 'part-time-hourly',
    SELF_EMPLOYED: 'selfemployed',
    OTHER: 'other',
};

const IncomeTypeEnum = types.enumeration('IncomeType', Object.values(INCOME_TYPES));

export {
    IncomeTypeEnum,
};
export default INCOME_TYPES;
